$(document).ready(function () {
    const initDelay = 2000;
    const disableEntryOn = [
        '404',
        'companyinfo',
        'how_it_works',
        'blog',
        'newsroom',
        'privacy',
        'cookies-policy',
        'terms_of_website_use',
        'subscribe',
        'da20',
        'events',
        'krypto-etp-startseite'
    ];
    let countrySelectActive = false;
    const countryPendingAccept = {
        'name': '',
        'iso': $.cookie("iso")
    };

    function initEntry() {
        const disableEntry = disableEntryOn.some(check => location.href.includes(check));
        const autoCountry = $('[data-auto-country]').attr('data-auto-country');

        if (!$.cookie("investor")) {
            $.cookie("investor", '0', { path: '/', secure: true });
        }

        if (!$.cookie("iso")) {
            $.cookie("iso", autoCountry || 'other', { path: '/', secure: true });
        }

        $('[data-entrysitelang]').val(getCountryLang($.cookie("iso")));

        translateEntry(getCountryLang($.cookie("iso")));
        $(`[data-entry-investor=${$.cookie("investor")}]`).addClass('active');

        if (!disableEntry && !$.cookie('filterAccepted')) {
            setTimeout(() => {
                $('#entryModal').toggleClass('show');
                showInvestorStep(true);
            }, initDelay);
        }

        if ($.cookie('filterAccepted') && !$.cookie('cookiehide')) {
            $('.aside-cookiewrap').addClass('show');
        }

        $(`[data-entry-country="${$.cookie("iso")}"]`).addClass('active');
    }

    function translateEntry(lang) {
        const default_str = window.entry_lang.en;
        const lang_str = window.entry_lang[lang] || default_str;

        $('#entryModal .lang').each(function () {
            const key = $(this).attr('data-translationindex');
            $(this).html(lang_str[key] || default_str[key]);
        }
        )
    }

    function locateToLang(lang) {
        var lang = lang || $.cookie('iso') || entryFilterBlock.dataset.iso;
        var pathname = location.pathname.replace(
            /^\/(\w{2}\/)?/,
            lang == 'en' ? '/' : `/${lang}/`
        )
        if (pathname == location.pathname) {
            window.location.reload()
        } else {
            window.location.href = pathname;
        }
    }

    function getCountryLang(country) {
        const siteLang = {
            de: 'de',
            fr: 'fr',
            it: 'it',
            at: 'de',
            default: 'en'
        };
        return siteLang[country] || siteLang.default;
    }

    function showGroups(groupsArray) {
        $('#entryModal [data-group]').each(function () {
            $(this).addClass('d-none');

            let groups = $(this).attr('data-group').split(',');

            for (group of groups) {
                if (groupsArray.includes(group)) $(this).removeClass('d-none');
            }
        })
    }

    $('[data-entry-country]').click(function () {
        const country = $(this).attr('data-entry-country');
        
        countryPendingAccept.iso = country;
        countryPendingAccept.name = $(this).attr('data-entry-country-name');

        $('[data-entry-country]').removeClass('active');
        $(this).addClass('active');
    });

    function renderCountrySelector() {
        $.cookie("iso", countryPendingAccept.iso, { path: '/', secure: true });
        
        $('[data-entry-selected-country] img').attr('src', `/static/images/flags/png/${countryPendingAccept.iso}@2x.png`)
        $('[data-entry-select-country]').text(countryPendingAccept.name);
        $('[data-entrysitelang]').val(getCountryLang($.cookie("iso")))
        translateEntry(getCountryLang($.cookie("iso")));
    }

    $('#acceptCountry').click(() => {
        renderCountrySelector();
        showInvestorStep(true);
    });

    $('#acceptCountryHeader').click(() => {
        renderCountrySelector();
        showInvestorStep(false);
    });

    $('[data-entry-investor]').click(function () {
        const investor = $(this).attr('data-entry-investor')
        $.cookie("investor", investor, { path: '/', secure: true });
        $('[data-entry-investor]').removeClass('active');
        $(this).addClass('active');

        showInvestorStep(true);
    });

    function showInvestorStep(keepInEntry) {
        const settingsGroup = mobileTrigger ? 'body_settings' : 'title_settings';

        if ($.cookie("iso") == 'other') {
            showGroups([settingsGroup, 'other']);
            return;
        };
        if ($.cookie("iso") == 'gb' && $.cookie("investor") == '0') {
            showGroups([settingsGroup, 'country_unavailable', 'investor']);
            return;
        };
        if ($.cookie("iso") == 'us') {
            showGroups([settingsGroup, 'investor_us']);
            return;
        };
        if ($.cookie("iso") == 'fr') {
            showGroups([settingsGroup, 'terms', 'investor', 'french_alert']);
            return;
        }

        if (keepInEntry) {
            showGroups([settingsGroup, 'terms', 'investor']);
        } else {
            locateToLang(getCountryLang($.cookie('iso')));
        }
    }

    $('#cookieD').click(function () {
        if ($('#optCookies').attr('data-switch') === 'on') $('#optCookies').click();
    });
    $('#optCookies').click(function () {
        const trigger = $(this).attr('data-switch');

        if (trigger == 'off') {
            $('[data-optional-cookies="target"]').attr('type', 'text/plain');
            $.cookie('optionalCookies', 'disabled', {
                path: '/', secure: true
            })
        } else {
            $('[data-optional-cookies="target"]').attr('type', 'text/javascript');
            $.cookie('optionalCookies', 'allowed', {
                path: '/', secure: true
            })
        }
    })
    $('#cookieB').click(() => {
        $.cookie("cookiehide", 1, { path: '/', secure: true });
        $('.aside-cookiewrap').removeClass('show');
    });

    $('#leaveSiteBtn').click(() => location.href = 'https://www.google.com/');

    $('#gotoBWBtn').click(() => location.href = 'https://bitwiseinvestments.com/');

    $('[data-entry-selected-country]').click(() => {
        const settingsGroup = mobileTrigger ? '' : 'title_settings';
        if (countrySelectActive) {
            showInvestorStep(true);
        } else {
            showGroups([settingsGroup, 'countries'])
        }
        countrySelectActive = !countrySelectActive;
    });

    $('[data-open-country]').click(() => {
        $('#entryModal').toggleClass('show');
        showGroups(['countries_header'])
    });

    $('[data-open-investor]').click(() => {
        $('#entryModal').toggleClass('show');
        showInvestorStep(true);
    });

    $('[data-entrysitelang]').change(function () {
        translateEntry($(this).val())
    })

    $('#acceptSettings, #acceptOther, #keepEUBtn').click(() => {
        $.cookie('filterAccepted', true, { path: '/', secure: true });
        locateToLang(getCountryLang($.cookie('iso')));
    })

    initEntry();
})